import config from '../../../../config/config';
import { CompanyTypesApi, Configuration } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const companyTypesApi = new CompanyTypesApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
